const state = {};

const getters = {};

const mutations = {};

const actions = {
  async fetchAll(ctx) {
    try {
      let {
        data: { data: taxpayers },
      } = await axios.get('/api/taxpayers');
      return taxpayers;
    } catch (error) {
      throw error.response.data;
    }
  },

  async add(ctx, data) {
    try {
      let {
        data: { success, message },
      } = await axios.post('/api/taxpayers', data);
      return { success, message };
    } catch (error) {
      throw error.response.data;
    }
  },

  async fetchByID(ctx, id) {
    try {
      let {
        data: { data: taxpayer },
      } = await axios.get(`/api/taxpayers/${id}`);
      return taxpayer;
    } catch (error) {
      throw error.response.data;
    }
  },

  async updateByID(ctx, { id, data }) {
    try {
      let {
        data: { success, message },
      } = await axios.put(`/api/taxpayers/${id}`, data);
      return { success, message };
    } catch (error) {
      throw error.response.data;
    }
  },

  async deleteByID(ctx, id) {
    try {
      let {
        data: { success, message },
      } = await axios.post(`/api/taxpayers/${id}`, { _method: 'delete', taxpayer: id });
      return { success, message };
    } catch (error) {
      throw error.response.data;
    }
  },
};

const namespaced = true;

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced,
};
